// extracted by mini-css-extract-plugin
export var actions = "_4k-0";
export var actionsContainer = "_4k-6";
export var border = "_4k-1";
export var childFullHeight = "_4k-d";
export var collapse = "_4k-2";
export var content = "_4k-8";
export var contentChild = "_4k-c";
export var fullscreen = "_4k-a";
export var headerContainer = "_4k-3";
export var headerRow = "_4k-5";
export var hidePadding = "_4k-9";
export var noScrollX = "_4k-e";
export var noScrollY = "_4k-f";
export var optOutTopPadding = "_4k-b";
export var pagePadding = "_4k-7";
export var profile = "_4k-g";
export var profileContainer = "_4k-h";
export var profileImage = "_4k-i";
export var profileMain = "_4k-j";
export var profileSubtitle = "_4k-l";
export var profileTitle = "_4k-k";
export var tabsWrapper = "_4k-4";
export var title = "_4k-m";